import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { TableCombination, TableCombinationGroup } = protos;

/**
 * fetch all table combinations
 */
export function fetchAllTableCombinations(): ApiAction {
  return {
    TockApi: {
      getListProto: '/table/combination',
      type: AppConstants.TABLECOMBINATION_FETCH_ALL,
    },
  };
}

/**
 * Create a table.
 *
 * @param {tableCombination} tableCombination The table to create.
 * @returns {Object} A redux TockApi action.
 */
export function createTableCombination(tableCombination: dashboard.ITableCombination): ApiAction {
  const request = TableCombination.fromObject(tableCombination);

  return {
    TockApi: {
      postProto: '/table/combination',
      type: AppConstants.TABLECOMBINATION_CREATE,
      request,
    },
  };
}

/**
 * Create a table.
 *
 * @param {tableCombination} tableCombination The table to create.
 * @returns {Object} A redux TockApi action.
 */
export function createAllAdjacentTableCombinations(
  group: dashboard.ITableCombinationGroup
): ApiAction {
  const request = TableCombinationGroup.fromObject(group);
  return {
    TockApi: {
      postProto: '/table/combination/group',
      type: AppConstants.TABLECOMBINATION_CREATE,
      request,
    },
  };
}

/**
 * Create a table.
 *
 * @param {tableCombination} tableCombination The table to create.
 * @returns {Object} A redux TockApi action.
 */
export function deleteTableCombination(id: number): ApiAction {
  return {
    TockApi: {
      deleteProto: `/table/combination/${id}`,
      type: AppConstants.TABLECOMBINATION_DELETE,
      context: { deletedTableCombinationId: id },
    },
  };
}
